import DockContent from './DockContent';

/**
 * FooterBar - Mobile-only bottom filter bar
 * Wraps DockContent with full-width scrollable footer styling
 * Hidden on desktop via CSS
 */
export default function FooterBar() {
  return (
    <div className="footer-bar">
      <DockContent />
    </div>
  );
}
